module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAFlUW0AAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAACKADAAQAAAABAAAADgAAAAAaxI7yAAAA5klEQVQYGWNgAIH///8zgRkI4tixY9IIHoh19OhRfwagcBeIw/Tv3z8nEAMMgFIvGWEcoJJsIPsQSMOSEydO8MEk4DRQ4j6cA2McOXLkAowN0voUmXMNmXMQzgEyQO6+eebMGRFkQZD+aiBWBgnCHQYUiGFiYroNF0DWApIE8nuBCvxYkCWA7qpiZGRMBYq5WFtbi4PkGEEBBvTnDCBtxMHB4WFiYvIGWRMLUHIRUECWhYXFCSj5CVkSxIa7AWh8N9B4byB2tbKygvsargCmExSsQOuqgHx3oDuuYCiAKQT6xB+osBEAoi5g4RoZuz0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/page-component/page-component/left.png
// module id = spfx
// module chunks = 35